<div class="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-900">
    <!-- ===== Sidebar ===== -->
    <app-sidebar 
      #sidebarComponent
      (sidebarToggled)="onSidebarToggled($event)">
    </app-sidebar>
    <!-- ===== Sidebar End ===== -->

    <!-- ===== Content Area Start ===== -->
    <div class="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden transition-all duration-300 ease-in-out">
        <!-- ===== Header Start ===== -->
        <app-header 
          [sidebarCollapsed]="sidebarCollapsed"
          (toggleSidebar)="onHeaderToggleSidebar()">
        </app-header>
        <!-- ===== Header End ===== -->
        
        <!-- ===== Banner de Tarea Diaria ===== -->
        <app-daily-task-banner></app-daily-task-banner>

        <!-- ===== Main Content Start ===== -->
        <main class="mt-4">            
                <router-outlet></router-outlet>            
        </main>
        <!-- ===== Main Content End ===== -->
    </div>
    <!-- ===== Content Area End ===== -->
</div>
    